import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddComparableItemButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/comparable_items/create?comparatorConfig=${record['@id']}`}
    label="Add a comparable item"
    title="Add a comparable item"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddComparableItemButton);
